const common = {
    no_data: 'データがありません',
    header: {
        business_name: 'あなたのビジネス'
    },
    download_app: {
        text: 'SimplyのWebバージョンを使用するには、ノートパソコンまたはPCをご利用ください。',
        button: 'モバイル版をダウンロード'
    },
    unknown: '不明',
    request_error: 'エラーが発生しました。もう一度お試しください。問題が続く場合はカスタマーサポートにご連絡ください。',
    home: 'ホーム',
    dashboard: 'ダッシュボード',
    product: '商品',
    add_product: '商品を追加',
    edit_product: '商品を編集',
    stock_in: '入庫',
    Sales_Turnover: '売上高',
    profit: '利益',
    stock_out: '出庫',
    staff: 'スタッフ',
    stock_audit: '在庫監査',
    button: {
        save: '保存',
        save_and_add_more: '保存して追加',
        submit: '送信',
        done: '完了',
        edit: '編集',
        save_edit: '変更を保存',
        yes: 'はい',
        clear: 'クリア',
        delete: '削除',
        cancel: 'キャンセル',
        reset: 'リセット'
    },
    select_date: '日付を選択',
    select_action: '操作を選択',
    mandatory: ' *(必須)',
    not_mandatory: '(任意)',
    business: 'ビジネス',
    account: 'アカウント',
    profile: 'プロフィール',
    setting: '設定',
    whichLanguage: '日本語',
    headerDashboard: 'VIPになる',
    contact_us: 'お問い合わせ',
    logout: 'ログアウト',
    category: 'カテゴリー',
    add_category: 'カテゴリを追加',
    data: 'データ',
    history: '履歴',
    lowStockAlert: '在庫不足アラート',
    Expenses: '経費',
    lowStockAlertButton: '安全在庫数量を追加',
    message: {
        login_success: 'ログインに成功しました！',
        onboard_success: 'おめでとうございます！旅が始まりました！',
        successfully_saved: 'データが正常に保存されました',
        successfully_deleted: 'データが正常に削除されました',
        error_required_field: '必須項目は空にできません',
        no_access: 'アクセス権がありません',
        no_permission: "権限がありません",
        error_update_history: '履歴の更新に失敗しました'
    },
    no_permission_dialog: {
        title: '権限がありません',
        description: '支出を表示する権限がありません。管理者に連絡してください。'
    },
    feedback: 'フィードバックを送信',
    contact: '連絡先',
    add: '追加',
    supplier: '仕入先',
    customer: '顧客',
    random: 'ランダム',
    scan: 'スキャン',
    enter: 'バーコードをスキャンしてログイン',
    terms: {
        text: '続行すると、次に同意したものと見なされます',
        link: 'プライバシーポリシー'
    },
    others: 'その他',
    calender: {
        presets: {
            today: '今日',
            yesterday: '昨日',
            last_7_days: '過去7日間',
            last_30_days: '過去30日間',
            this_month: '今月',
            last_month: '先月',
            custom_range: 'カスタム範囲'
        }
    },
    print_large: '大型印刷 (A4)',
    print_letter: 'レター印刷 (US)',
    print_dot_matrix: '大型印刷 (ドットマトリックス)',
    print_medium: '中型印刷 (75mm)',
    print_small: '小型印刷 (48mm)',
    format: '用紙形式',
    preview: 'プレビュー',
    view_invoice: '請求書',
    view_chalan: '送り状',
    price: '価格',
    stock: '在庫',
    quantity: '数量',
    total: '合計',
    print_footer_left: '作成者',
    print_footer_center: '印刷日',
    print_footer_date: '日付',
    print_to: '宛先',
    language: '日本語',
    dateStatus: '過去7日間',
    placeholder: '取引タイプ',
    staffHistory: 'スタッフを選択',
    languageTitle: '日本語',
    date: '日付',
    download: 'ダウンロード',
    download_excel: 'Excelをダウンロード',
    download_pdf: 'バーコードをダウンロード',
    currentTitle: '通貨',
    Selectperiod: '期間を選択',
    TransactionType: '取引タイプ',
    SelectCustomer: '顧客を選択',
    invoice: '請求書',
    login: {
        google: 'Googleでログイン',
        apple: 'Appleでログイン'
    },
    trusted_by: {
        title: 'インドネシア 🇮🇩 全土で50,000社以上の企業に信頼されています'
    },
    privacyPolicyOne: "ログインすることでSimplyの",
    privacyPolicyTwo: 'プライバシーポリシー',
    manufacture: '製造業者',
    warehouse: '倉庫',
    error: {
        title: 'おっと！何か問題が発生しました',
        description: '予期せぬエラーが発生しました。ページを更新するか、ホームに戻ってください。',
        refresh: 'ページを更新',
        go_back: 'ホームに戻る',
        not_found: 'ページが見つかりません'
    },
    totalPurchasePrice: '合計仕入価格',
    pageTotalPurchaseAmount: 'ページ合計購入金額',
    approval_status: '承認ステータス',
    pending: '保留中',
    approved: '承認済み',
    rejected: '却下済み',
    select_fields: 'フィールドを選択',
    syncWithTally: 'Tallyと同期',
    importFromTally: 'Tallyからインポート',
    exportToTally: 'Tallyへエクスポート',
    All: 'すべて',
    Approval: '承認'
}

export default common;
